// Shared content used across the marketing pages.
// NOTE: testimonials below are SAMPLE text – replace with real, approved client quotes before launch.

export const testimonials = [
  { quote: "They treated our marketing as one connected system. Within a few months our enquiries were more consistent and far better qualified.", by: "Founder", org: "D2C e-commerce brand", initials: "F" },
  { quote: "Clear reporting, quick responses and no vanity metrics. We always knew what was working and what was being changed next.", by: "Marketing Head", org: "Healthcare provider", initials: "M" },
  { quote: "From website to ads to follow-up, one team handled it all. Our sales team noticed the difference in lead quality almost immediately.", by: "Director", org: "Real estate developer", initials: "D" },
];

export const sadhna = [
  ["Discipline", "Great marketing is built on routines: weekly optimisation, monthly reviews and quarterly planning that never get skipped."],
  ["Consistency", "Results compound when effort is steady. We show up the same way in month twelve as we do in month one."],
  ["Clarity", "Plain-language reporting and honest conversations, including about what is not working yet."],
  ["Outcomes", "We measure ourselves by leads, revenue and growth in your business, not by activity or hours."],
];

export const homeWhy = [
  ["One accountable team", "Strategy, creative, media, web and automation live under one roof, so nothing falls between agencies."],
  ["Built for Indian and global markets", "Experience across India, the UAE, the UK and the US means we understand different buyers, platforms and budgets."],
  ["Senior attention", "Experienced strategists stay involved in your account instead of handing it off after the pitch."],
  ["Systems that compound", "Better data improves creative, better creative improves conversion and better conversion lowers your costs."],
];

export const markets = [
  ["🇮🇳", "India", "Headquartered in Varanasi, serving businesses across metros and growing cities, with local-language and regional campaign expertise."],
  ["🇦🇪", "UAE", "Campaigns for Dubai, Abu Dhabi and Sharjah, including bilingual content and local search visibility."],
  ["🇬🇧", "United Kingdom", "SEO, paid media and websites for UK businesses, with attention to GDPR-aware tracking."],
  ["🇺🇸", "United States", "Performance marketing and content programs for US startups and service businesses."],
];

export const tools = [
  "Google Ads", "Google Analytics 4", "Search Console", "Tag Manager", "Meta Ads", "LinkedIn Ads",
  "SEMrush", "Ahrefs", "Screaming Frog", "Looker Studio", "HubSpot", "Zoho CRM",
  "Shopify", "WordPress", "React", "Figma", "Mailchimp", "Klaviyo", "Make", "n8n",
];

export const capabilities = [
  "Technical SEO", "Local SEO", "Content SEO", "AI Engine Optimisation", "Google Search Ads", "Performance Max",
  "YouTube Ads", "Meta Ads", "LinkedIn Ads", "Organic Social", "Short-form Video", "Influencer Marketing",
  "Copywriting", "Brand Identity", "Graphic Design", "Website Design", "Web Development", "Conversion Optimisation",
  "Email Marketing", "WhatsApp Marketing", "Marketing Automation", "AI Chatbots", "Analytics & Dashboards", "CRM Integration",
];

export const teamRoles = [
  ["Growth Strategist", "Owns the plan, the goals and the commercial thinking behind every channel."],
  ["Performance Specialist", "Manages search and social campaigns, budgets, testing and conversion tracking."],
  ["SEO & Content Lead", "Leads technical SEO, content strategy and authority building."],
  ["Creative Director", "Shapes concepts, design and video so the brand stays distinctive."],
  ["Web & Automation Engineer", "Builds fast websites, integrations and automation workflows."],
  ["Account Manager", "Your day-to-day contact for updates, approvals and priorities."],
];

export const workingWith = [
  "A named account manager and regular check-ins",
  "A shared roadmap so you always know what is next",
  "Monthly reporting in plain language, with a call to discuss it",
  "Access to your own ad accounts, analytics and assets",
  "Honest recommendations, including when we advise against spending",
];

export const homeProcess = [
  ["01", "Discover", "We study your business, customers, competitors and data."],
  ["02", "Plan", "We turn insights into a roadmap with clear goals and priorities."],
  ["03", "Execute", "Creative, campaigns, content and tech go live together."],
  ["04", "Grow", "We test, report and scale what works."],
];

export const callIncludes = [
  "A review of your current website, search presence and ads",
  "Quick wins you can act on straight away",
  "Honest guidance on channels, budgets and timelines",
  "A suggested roadmap for the next 90 days",
  "No obligation and no pressure to sign up",
];

export const serviceChooser = [
  ["I want more calls and enquiries from Google", "SEO + Google Ads", "/services/seo"],
  ["I need leads quickly for a launch or offer", "Google Ads & landing pages", "/services/ppc"],
  ["I want to build an audience and brand presence", "Social media + content", "/services/social-media"],
  ["My website looks dated or does not convert", "Web design & development", "/services/web-development"],
  ["I need a stronger identity and positioning", "Branding & creative design", "/services/branding"],
  ["I have customers but low repeat sales", "Email & WhatsApp marketing", "/services/email-whatsapp"],
  ["My team wastes time on manual work", "AI & marketing automation", "/services/ai-automation"],
];

export const engagementModels = [
  ["Monthly retainer", "Ongoing support for SEO, paid media, social and optimisation, with a consistent team and monthly reporting."],
  ["Project-based", "A defined scope and timeline for a website, brand identity, campaign launch or automation build."],
  ["Integrated growth pod", "A dedicated cross-functional team covering strategy, creative, media and technology for ambitious brands."],
];

export const siloVsIntegrated = [
  ["Strategy", "Each vendor plans separately", "One plan across every channel"],
  ["Data", "Reports that do not match", "A single source of truth"],
  ["Creative", "Inconsistent message and look", "Consistent brand and tested hooks"],
  ["Accountability", "Vendors point at each other", "One team owns the outcome"],
  ["Speed", "Slow approvals and hand-offs", "Fast, coordinated execution"],
];

export const industryFraming = [
  ["Different buyers", "A patient, a homebuyer and an online shopper research and decide in very different ways."],
  ["Different rules", "Some industries have advertising or privacy regulations that shape what we can say and where."],
  ["Different economics", "Margins, lead values and sales cycles decide how much you can spend to acquire a customer."],
];

export const measurement = [
  ["Business outcomes first", "Leads, revenue, bookings and customer value come before clicks and impressions."],
  ["Clean tracking", "GA4, tag management and CRM integration ensure numbers are trustworthy."],
  ["Context, not just charts", "Every report explains what changed, why it matters and what we will do next."],
  ["Regular rhythm", "Weekly optimisation, monthly reviews and quarterly planning keep strategy moving."],
];

// Process page extras
export const processDetails = {
  "01": { time: "Week 1 to 2", deliverables: ["Stakeholder interviews", "Audit of site, search and ads", "Competitor and audience research"], needs: ["Access to analytics and ad accounts", "Current brand and sales information", "Your top three business goals"] },
  "02": { time: "Week 2 to 3", deliverables: ["Positioning and messaging", "Channel and budget plan", "KPIs and measurement framework"], needs: ["Feedback on the proposed plan", "Budget and resourcing decisions", "Approval of priorities"] },
  "03": { time: "Week 3 to 6", deliverables: ["Creative and content assets", "Website or landing pages", "Campaigns, tracking and automations"], needs: ["Timely approvals on creative", "Product or service details", "Access to key team members"] },
  "04": { time: "Week 5 to 7", deliverables: ["Pre-launch QA checklist", "Tracking validation", "Baseline performance dashboard"], needs: ["Sign-off for go-live", "Sales team readiness for leads", "Contact for urgent issues"] },
  "05": { time: "Ongoing, weekly", deliverables: ["Weekly optimisation actions", "Creative and landing page tests", "Search-term and audience reviews"], needs: ["Lead quality feedback", "Updates on offers and stock", "Sales outcome data"] },
  "06": { time: "Ongoing, quarterly", deliverables: ["Scaling plan for proven channels", "New market or audience tests", "Quarterly strategy refresh"], needs: ["Alignment on growth targets", "Decisions on new budgets", "Collaboration across teams"] },
};

export const reportingRhythm = [
  ["Weekly", "Short update on spend, leads, tests and next actions."],
  ["Monthly", "Full performance report and a call to review results and priorities."],
  ["Quarterly", "Strategy review, roadmap refresh and budget planning."],
];

export const processFaqs = [
  ["How long before I see results?", "Paid campaigns can produce leads within weeks of launch. SEO and brand programs build over 3 to 6 months and beyond. We agree on realistic milestones during the planning stage."],
  ["How involved do I need to be?", "We need your input at key points: goals, approvals, access and feedback on lead quality. Most clients spend an hour or two a week once the engagement is running."],
  ["Can we start small?", "Yes. Many clients begin with an audit or a single channel, then expand once the first results are visible."],
  ["Who will I talk to day to day?", "You get a named account manager, with specialists joining calls whenever there is something to decide."],
];

// Pricing page extras
export const pricingFactors = [
  ["Scope of services", "The number of channels and deliverables included in your program."],
  ["Market competitiveness", "How crowded your category and geography are."],
  ["Complexity", "Number of locations, products, integrations or languages to manage."],
  ["Support level", "Frequency of meetings, reporting and the size of the dedicated team."],
  ["Creative volume", "How many designs, videos and pieces of content you need each month."],
  ["Ad spend", "Media budgets are paid directly to platforms and are separate from our fees."],
];

export const pricingCompare = [
  ["Strategy & audit", true, true, true],
  ["SEO foundation", true, true, true],
  ["Monthly reporting", true, true, true],
  ["Performance marketing", false, true, true],
  ["Content & creative", false, true, true],
  ["Conversion optimisation", false, true, true],
  ["Weekly optimisation", false, true, true],
  ["Dedicated strategy team", false, false, true],
  ["Advanced automation", false, false, true],
  ["Custom reporting & dashboards", false, false, true],
];

export const addOns = [
  "Website redesign or landing page sprints",
  "Brand identity and guidelines",
  "Video and Reels production packs",
  "WhatsApp Business API setup",
  "CRM setup and automation",
  "Analytics and dashboard build",
  "AI chatbot for website or WhatsApp",
  "Marketing training for your team",
];

export const pricingFaqs = [
  ["Do you publish fixed prices?", "We scope programs around your goals, channels and complexity, so prices differ. After a short discovery call we send a clear proposal with what is included."],
  ["Is ad spend included in your fee?", "No. Ad budgets are paid directly to platforms such as Google and Meta, and our management fee is separate. You always keep control of your ad accounts."],
  ["Is there a long-term contract?", "Retainers typically run on a monthly or quarterly commitment, and the exact terms are agreed in your proposal. Projects are billed by milestone."],
  ["Can I change my plan later?", "Yes. As your needs grow or change, we can scale the scope of work up or down."],
  ["What if I only need one service?", "That is fine. Many clients start with a single service such as SEO, ads or a website, and add others later."],
];

// Contact page extras
export const contactSteps = [
  ["We read your message", "A strategist reviews your enquiry and prepares a few questions."],
  ["We reply promptly", "You hear back from us with a suggested time for a discovery call."],
  ["Discovery call", "We discuss goals, current marketing, timelines and budget."],
  ["Proposal", "You receive a clear scope, plan and next steps, with no obligation."],
];

export const contactPrepare = [
  "Your website address and key social profiles",
  "What you sell and who your ideal customers are",
  "Your main goal for the next 3 to 6 months",
  "Any current marketing activity and budgets",
  "Competitors or brands you admire",
];

export const contactFaqs = [
  ["How quickly will you respond?", "We aim to respond to new enquiries promptly during business days. For faster answers, message us on WhatsApp."],
  ["Do you work with clients outside India?", "Yes. We serve clients across India, the UAE, the UK and the US, and work remotely through video calls and shared dashboards."],
  ["Can we meet in person?", "Yes. You are welcome to visit our Varanasi office by appointment."],
];

// Resources page extras
export const glossary = [
  ["CAC", "Customer Acquisition Cost: the total marketing and sales cost of winning one new customer."],
  ["CPL", "Cost Per Lead: how much you spend, on average, to generate one enquiry."],
  ["ROAS", "Return On Ad Spend: revenue generated for every rupee spent on advertising."],
  ["CTR", "Click-Through Rate: the share of people who saw an ad or result and clicked it."],
  ["CRO", "Conversion Rate Optimisation: improving the share of visitors who take a desired action."],
  ["LTV", "Lifetime Value: the total revenue or profit a customer brings over their relationship with you."],
  ["SERP", "Search Engine Results Page: the page of results shown after someone searches."],
  ["Core Web Vitals", "Google's measures of loading speed, interactivity and visual stability."],
  ["Schema markup", "Code that helps search engines understand the meaning of your content."],
  ["AIEO", "AI Engine Optimisation: structuring content so AI assistants can find and cite it accurately."],
  ["Remarketing", "Showing ads to people who have already visited your site or engaged with your brand."],
  ["UTM parameters", "Tags added to links so analytics can show which campaign sent each visitor."],
];

export const guides = [
  ["Website launch checklist", "Tracking, speed, SEO and QA items to verify before going live."],
  ["Google Ads account health check", "A simple list to spot wasted spend and missing tracking."],
  ["90-day local SEO plan", "Week-by-week priorities for Maps and local search visibility."],
  ["Content calendar framework", "Pillars, formats and a rhythm for consistent social media."],
];
